module.exports = __webpack_public_path__ + "img/character-traits.39cc567c.svg";